export default __webpack_public_path__ + "static/media/index-img6.5808f4a5.jpeg";